
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/errors/sandbox",
      function () {
        return require("private-next-pages/docs/errors/sandbox.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/errors/sandbox"])
      });
    }
  